import { useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { setUnauthenticated } from '../../../utils/auth';

export const Logout = () => {
  useEffect(() => {
    setUnauthenticated();
  }, []);

  return <Navigate to='/' replace />;
};
